export const WEB_ROOT =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://knu-market-poc.vercel.app';

export const GOOGLE_FORM_LINK = 'https://forms.gle/Er7LT1rFHPbH94Jd6';
